const normalizedId = (id) => String(id || "").toLowerCase();

export function isSpecificToOfferCustomer(partida, customerId) {
	return Boolean(
		partida?.cliente_id &&
		customerId &&
		normalizedId(partida.cliente_id) === normalizedId(customerId)
	);
}

export function isAvailableToOfferCustomer(partida, customerId) {
	return !partida?.cliente_id || isSpecificToOfferCustomer(partida, customerId);
}
